import React from "react";
import BreadCrumb from "../Common/BreadCrumb";
import WelcomeCard from "../../Components/adminComponents/DashboardOverview/WelcomeCard";
import InfoCads from "../../Components/adminComponents/DashboardOverview/InfoCads";
import Calendar from "../../Components/adminComponents/DashboardOverview/Calendar";

const DashboardHome = () => {
  return (
    <div className="p-5">
      <BreadCrumb title="Dashboard Overview" trail={["Dashboard"]} />

      <WelcomeCard />

      <InfoCads />

      <section className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <Calendar />
        {/* Recent Activity */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 md:p-5 lg:col-span-2">
          <div className="flex items-center justify-between mb-3">
            <h2 className="text-base md:text-lg font-semibold text-gray-900">
              Recent Activity
            </h2>
            <button className="text-xs text-indigo-600 hover:underline">
              View all
            </button>
          </div>
          <div className="space-y-3">
            {[
              {
                title: "New user registered",
                desc: "Manas joined the platform.",
                time: "5 mins ago",
              },
              {
                title: "Payment received",
                desc: "₹3,500 for React Bootcamp.",
                time: "30 mins ago",
              },
              {
                title: "Course updated",
                desc: "JavaScript Basics syllabus updated.",
                time: "1 hour ago",
              },
            ].map((item, idx) => (
              <div
                key={idx}
                className="flex items-start justify-between border-b border-gray-100 last:border-0 pb-3 last:pb-0"
              >
                <div>
                  <p className="text-sm font-medium text-gray-900">
                    {item.title}
                  </p>
                  <p className="text-xs text-gray-500 mt-0.5">{item.desc}</p>
                </div>
                <span className="text-[11px] text-gray-400">{item.time}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default DashboardHome;
